/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useState } from 'react';
import { ethers } from 'ethers'
import SimpleMetadata from './artifacts/contracts/SimpleMetadata.sol/SimpleMetadata.json'
import reBurnToken from './artifacts/contracts/reBurnToken.sol/reBurnToken.json'

function ConfigureToken(props) {
    const {web3, myToken } = props;

    const [myTokenInfo, setMyTokenInfo] = useState({
        loaded: false,
        symbol: "",
        name: "",
        uri: "",
        logo: "",
        facebook: "",
        twitter: "",
        discord: "",
        telegram: "",
        email: "",
        staking: "",
        uriset: ""
    })

    function bumpState(newStateChunk) {
        setMyTokenInfo(prev => {return {
                ...prev,
                ...newStateChunk
        }});
    }

    async function getTokenInfo(address) {
        console.log("Load token info");
        const lifeContract = new ethers.Contract(address, reBurnToken.abi, web3)
        const metadata = await lifeContract.metadataFor(["logo", "com.facebook", "com.twitter", "com.discord", "org.telegram", "email", "staking", "uriset"]);
        return {
            loaded: true,
            symbol: await lifeContract.symbol(),
            name: await lifeContract.name(),
            uri: await lifeContract.uri(),
            logo: metadata[0],
            facebook: metadata[1],
            twitter: metadata[2],
            discord: metadata[3],
            telegram: metadata[4],
            email: metadata[5],
            staking: metadata[6],
            uriset: metadata[7],
        };
    }

    function handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        bumpState({[name]: value})
    }

    if (!myTokenInfo.loaded)
        getTokenInfo(myToken).then(setMyTokenInfo);

    async function saveTokenInfo(event) {
        event.preventDefault();

        const signer = web3.getSigner()
        const lifeContract = new ethers.Contract(myToken, SimpleMetadata.abi, signer)
        const keys = ["logo", "com.facebook", "com.twitter", "com.discord", "org.telegram", "email", "staking", "uri", "uriset"];
        const vals = [myTokenInfo.logo, myTokenInfo.facebook, myTokenInfo.twitter, myTokenInfo.discord,
            myTokenInfo.telegram, myTokenInfo.email, myTokenInfo.staking, myTokenInfo.uri, myTokenInfo.uriset];
        try{
            await lifeContract.setMetadataFor(keys, vals);
        } catch (e) {
            //ignore
            console.log(e);
        }
    }

    return (
        <div className="card">
          <div className="card-header">
              {myToken} {(!myTokenInfo.loaded) && "(Loading...)" }
          </div>
          <div className=" m-1 p-3">
        <form className="row g-3" onSubmit={saveTokenInfo}>
          <div className="col-md-6">
            <label htmlFor="inputEmail4" className="form-label">Symbol</label>
            <input type="text" className="form-control" id="inputEmail4" name="symbol" value={myTokenInfo.symbol} readOnly={true}/>
          </div>
          <div className="col-md-6">
            <label htmlFor="inputPassword4" className="form-label">Name</label>
            <input type="text" className="form-control" id="inputPassword4" name="name" value={myTokenInfo.name} readOnly={true}/>
          </div>
          <div className="col-12">
            <label htmlFor="staking" className="form-label">Staking contract address</label>
            <input type="text" className="form-control" id="staking" name="staking" value={myTokenInfo.staking} onChange={handleInputChange}/>
          </div>
          <div className="col-12">
            <label htmlFor="inputAddress" className="form-label">Logo image</label>
            <input type="text" className="form-control" id="inputAddress" placeholder="" name="logo" value={myTokenInfo.logo} onChange={handleInputChange}/>
          </div>
          <div className="col-12">
            <label htmlFor="inputAddress2" className="form-label">Website</label>
            <input type="text" className="form-control" id="inputAddress2" name="uri" value={myTokenInfo.uri} onChange={handleInputChange}/>
          </div>
          <div className="col-12">
            <label htmlFor="uriSet" className="form-label">Alternative websites (and version; format: <code>{`[{"uri": "http://...", "version": 1}, {"uri": "http://...", "version": 2},...]`}</code>)</label>
            <input type="text" className="form-control" id="uriSet" name="uriset" value={myTokenInfo.uriset} onChange={handleInputChange}/>
          </div>
          <div className="col-md-4">
            <label htmlFor="inputTwitter" className="form-label">Twitter</label>
            <input type="text" className="form-control" id="inputTwitter" name="twitter" value={myTokenInfo.twitter} onChange={handleInputChange}/>
          </div>
          <div className="col-md-8">
            <label htmlFor="inputFacebook" className="form-label">Facebook</label>
            <input type="text" className="form-control" id="inputFacebook" name="facebook" value={myTokenInfo.facebook} onChange={handleInputChange}/>
          </div>
          <div className="col-md-6">
            <label htmlFor="inputDiscord" className="form-label">Discord</label>
            <input type="text" className="form-control" id="inputDiscord" name="discord" value={myTokenInfo.discord} onChange={handleInputChange}/>
          </div>
          <div className="col-md-6">
            <label htmlFor="inputTelegram" className="form-label">Telegram</label>
            <input type="text" className="form-control" id="inputTelegram" name="telegram" value={myTokenInfo.telegram} onChange={handleInputChange}/>
          </div>
          <div className="col-12">
            <button type="submit" className="btn btn-primary" onClick={saveTokenInfo}>Save metadata</button>
          </div>
        </form>
        </div>
        </div>
    );
}

export default ConfigureToken;